import AOS from 'aos';

export default {

	init() {       
        let elems = document.querySelectorAll('[data-aos]');
        
        if (!elems.length) {
            return;
        }
        
        // @see https://github.com/michalsnik/aos?tab=readme-ov-file#1-initialize-aos
		AOS.init({
            duration: 1000,
            once: false,
        });
	},
    
}